import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";
import {IDocDetails} from "StateInterface";
import {DocTypes} from "myshubhlife-component/docInput";

export const updateSubStatuses = (applicationId: number, subStatuses: string[]) => {
    return axiosInstance.request({
        baseURL: gatewayUrl,
        url: `corleone/incomplete-info-on-complete`,
        method: "post",
        data: {applicationId, subStatuses},
    });
};

export const uploadDocument = (docType: DocTypes, docBody: IDocDetails) => {
    return axiosInstance.request({
        baseURL: gatewayUrl,
        url: `paandu/docs`,
        method: "post",
        data: docBody,
    });
};

export const getAccAggregatorLink = async (bankId: string, requestId: number): Promise<{
    live: boolean;
    type?: string;
    value?: string;
}> => {
    const res = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: "bs-service/account-aggregator-link",
        method: "get",
        params: {bankId, requestId},
    });
    return res.data;
};

export const fetchBankStatementStatus = async (): Promise<{is_bs_upload_allowed: boolean}> => {
    const res = await axiosInstance.request({
        baseURL: gatewayUrl,
        url: "corleone/is-bs-upload-allowed",
        method: "GET",
    });
    return res.data;
};
